import axiosInstance from '../axios';
import { apiBaseURL } from 'config/axios';
import { CalendarEventGet, mapResultToCalendarEventGet } from '../CalendarService';
import { Operador } from '../OperadoresService';
import { EstadoServicio, TipoServicio } from '../ServiciosService';
import { Cliente } from '../role_cliente/RoleClienteServices';

const entityApiRoute = 'operador';

export interface OperadorData {
  id: number;
  name: string;
  email: string;
  email_verified_at: Date;
  role: string;
  created_at: Date;
  updated_at: Date;
  deleted_at?: any;
  serviciosSemana: CalendarEventGet[];
  datosGenerales: DatosGenerales;
  operador: Operador;
}

export interface DatosGenerales {
  operadores: Operador[];
  tipoServicio: TipoServicio[];
  estadoServicio: EstadoServicio[];
  clientes: Cliente[];
}

const fetchOperadorData = async (): Promise<OperadorData> => {
  const url = `${apiBaseURL}/${entityApiRoute}/user`;
  const response = await axiosInstance.get(url);
  const tempResult: any = response.data?.result;
  //mapea los servicios a servicioEventGet
  const resultServiciosSemana = tempResult.serviciosSemana.map((googleEvent) => {
    // const entity = googleEvent.googleEvent;
    return mapResultToCalendarEventGet(googleEvent);
  });
  tempResult.serviciosSemana = resultServiciosSemana;
  return tempResult;
}

const updateEstadoServicio = async (id: string, updateData: { estado?: number }) => {
  const url = `${apiBaseURL}/${entityApiRoute}/servicios/${id}`;
  await axiosInstance.patch(url, updateData);
}


export default {
  fetchOperadorData,
  updateEstadoServicio
}
